export { StudentSettingsPreferencesPage } from "./StudentSettingsPreferencesPage"
export type { StudentSettingsPreferencesPageProps } from "./StudentSettingsPreferencesPage"
